import { Box, CircularProgress } from '@mui/material'

const Loading = ({ fullHeight = false }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: fullHeight ? '100dvh' : '100%'
    }}
  >
    <CircularProgress size={28} thickness={4} />
  </Box>
)

export default Loading
